import Uppy, { State } from '@uppy/core';
import { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';

export function useUppyState(uppy: Uppy) {
  const [uppyState, setUppyState] = useState(() => uppy.getState());
  const prevUppy = useRef(uppy);
  if (uppy !== prevUppy.current) {
    prevUppy.current = uppy;
    setUppyState(uppy.getState());
  }
  useEffect(() => {
    let animationFrameId = 0;
    const unsubscribeFromStore = (uppy as any).store.subscribe(
      (state: State, nextState: State) => {
        if (shallowEqual(state, nextState)) return;
        animationFrameId = requestAnimationFrame(() => {
          setUppyState(nextState);
        });
      }
    );
    return () => {
      unsubscribeFromStore();
      cancelAnimationFrame(animationFrameId);
    };
  }, [uppy]);
  return uppyState;
}
